import { configureClientCodeStyles } from '@onify/helix-core';
import { CLIENT_CODE_STYLES_CONFIG } from '../../.helix/client-code-styles';

configureClientCodeStyles(CLIENT_CODE_STYLES_CONFIG);
